export const labelMap: Record<string, string> = {
  boyut: 'Boyut',
  dem: 'Dem',
  seker: 'Şeker',
  sicaklik: 'Sıcaklık',
};

export const valueMap: Record<string, string> = {
  normal: 'Normal',
  double: 'Büyük',
  acik: 'Açık',
  demli: 'Demli',
  sekersiz: 'Şekersiz',
  orta: 'Orta',
  sekerli: 'Şekerli',
  sicak: 'Sıcak',
  ilik: 'Ilık',
  soguk: 'Soğuk',
};

export const getDisplayLabel = (key: string): string => {
  return labelMap[key] || key;
};

export const getDisplayValue = (value: string | number): string => {
  return valueMap[String(value)] || String(value);
};

export const formatOptionsForDisplay = (
  options: Record<string, any>
): Array<{ key: string; label: string; value: string }> => {
  return Object.entries(options).map(([key, value]) => ({
    key,
    label: getDisplayLabel(key),
    value: getDisplayValue(value),
  }));
};
